import { useState, useEffect } from 'react';
import './WelcomeScreen.css';

interface WelcomeScreenProps {
  onStartTutorial: () => void;
  onSkipTutorial: () => void;
}

export const WelcomeScreen = ({ onStartTutorial, onSkipTutorial }: WelcomeScreenProps) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Trigger fade-in animation
    setTimeout(() => setIsVisible(true), 50);
  }, []);

  return (
    <div className={`welcome-screen ${isVisible ? 'visible' : ''}`}>
      <div className="welcome-content">
        <h1 className="welcome-title">Simon Revolutions</h1>
        <p className="welcome-question">¿Es tu primera vez jugando Simon Revolutions?</p>
        
        <div className="welcome-buttons">
          <button 
            className="welcome-button primary"
            onClick={onStartTutorial}
          >
            Sí, muéstrame cómo jugar
          </button>
          
          <button 
            className="welcome-button secondary"
            onClick={onSkipTutorial}
          >
            No, ya sé jugar
          </button>
        </div>

        <button 
          className="skip-tutorial-link"
          onClick={onSkipTutorial}
        >
          Saltar tutorial
        </button>
      </div>
    </div>
  );
};
